	<div *ngIf="!isLoading  else loading">
		<p class="para-intro" translate>add-suborg.intro</p>
		<div *ngIf="matchingOrgs && matchingOrgs.length !== 0">
			<div class="matching-organizations">
				<p class="para-text" translate>add-suborg.matchin-org-intro</p>
				<ag-grid-angular class="ag-theme-balham org-list" [gridOptions]="gridOptions" [modules]="modules"
					[rowData]="matchingOrgs" (gridReady)="onGridReady($event)"></ag-grid-angular>
			</div>
		</div>
		<div class="matching-organizations" *ngIf="!isLoading && (!matchingOrgs || matchingOrgs.length === 0)">
			<p class="para-text" translate>add-suborg.new-org-intro</p>
			<ag-grid-angular class="ag-theme-balham" [gridOptions]="newSubOrgGridOptions" [modules]="modules"
				[rowData]="newSubOrgRowData" (gridReady)="onNewGridReady($event)"></ag-grid-angular>
		</div>
		<mat-error *ngIf="nextClicked && !isAnyOneSelected" translate>add-suborg.please-select</mat-error>
		<mat-error *ngIf="nextClicked && vatNumberExists && isNewSubOrg" translate>add-suborg.vat-num-already-exists
		</mat-error>
	</div>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>